import { render, staticRenderFns } from "./questionnairerecord.vue?vue&type=template&id=f703a432&scoped=true&"
import script from "./questionnairerecord.vue?vue&type=script&lang=js&"
export * from "./questionnairerecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f703a432",
  null
  
)

export default component.exports